import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const ShowMoreButtonContainer = styled.button`
  background: none;
  border: none;
  color: #f78e1e;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  white-space: nowrap;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: flex;
    font-weight: 400;
    font-size: 0.625rem;
    gap: 5px;
  }

  &:hover {
    background-color: none;
    color: darken(#f78e1e, 10%);
  }

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    color: #d9d9d9;
    cursor: not-allowed;

    &:hover {
      background: none;
      color: #d9d9d9;
    }
  }
`;
